import {gpsControlMatchesModel,gpsControlProfile,gpsControlAllows} from './gps-control-profile.js';
import {hasYoguIntervalCatalogue} from './gps-interval-presets.js';

// A model name alone never enables hardware control. Keep this aligned with
// the explicit firmware profile accepted by the server.
export function confirmedGpsControl(device) {
  const profile = device?.profile;
  return profile?.protocol === 'gt06' && gpsControlProfile(profile.gpsControl?.id)
    && gpsControlMatchesModel(profile.gpsControl?.id,profile.model) ? gpsControlProfile(profile.gpsControl.id) : null;
}

export function gpsFeatureAvailable(device, id) {
  if (device?.profile?.protocol !== 'gt06') return false;
  const features = device.profile.features ?? [], control = confirmedGpsControl(device);
  switch (id) {
    case 'gps-location': return features.includes('position');
    // Browsing planned intervals grants no command capability.
    case 'gps-interval': return gpsControlAllows(device.profile,'interval')||hasYoguIntervalCatalogue(device.profile);
    case 'gps-mode': return Boolean(control)&&(control.position!==false||control.modes===true||gpsControlAllows(device.profile,'sleep')||gpsControlAllows(device.profile,'acc'));
    case 'gps-maintenance': return Boolean(control)&&control.restart!==false;
    case 'gps-parameters': return control?.parameters === true;
    case 'gps-zones': return features.includes('geofence') && device.capabilities?.gpsZones === true;
    case 'gps-speed': return features.includes('speed') && device.capabilities?.speedAlerts === true;
    case 'gps-vibration': return features.includes('vibration') && control?.vibration !== false;
    case 'gps-removal': return features.includes('removal');
    case 'gps-battery': return features.includes('batteryLevel');
    case 'gps-network': case 'gps-time': case 'gps-notifications': return true;
    default: return false;
  }
}
